// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".parentContainer_JnORa{width:100%;margin-bottom:12px}.parentContainer_JnORa [style*=\"--aspect-ratio\"]>:first-child{width:100%}.parentContainer_JnORa [style*=\"--aspect-ratio\"]>img{height:auto}@supports(--custom:property){.parentContainer_JnORa [style*=\"--aspect-ratio\"]{position:relative}.parentContainer_JnORa [style*=\"--aspect-ratio\"]:before{content:\"\";display:block;padding-bottom:calc(100%/var(--aspect-ratio))}.parentContainer_JnORa [style*=\"--aspect-ratio\"]>:first-child{position:absolute;top:0;left:0;height:100%}}.parentContainer_JnORa .subContainer_V5lJg{min-height:460px}.parentContainer_JnORa .imgElement_pm-XT{width:100%;height:100%;-o-object-fit:contain;object-fit:contain;max-height:460px}", ""]);
// Exports
exports.locals = {
	"parentContainer": "parentContainer_JnORa",
	"subContainer": "subContainer_V5lJg",
	"imgElement": "imgElement_pm-XT"
};
module.exports = exports;
